// extracted by mini-css-extract-plugin
export default {"chip":"Form_chip__nbopC","label":"Form_label__B5Yyb"};